<template>
  <section>
    <form class="search-bar" @submit.prevent="trigger">
      <button
        type="button"
        class="btn--refresh"
        @click="refresh"
      >
        <i class="ico--refresh"></i>
      </button>

      <template v-if="!!(filterBy.length)">
        <div class="search-bar__items -filterby-dp">
          <select-list
            ref="filter"
            id="filter-by"
            :title="filterTitle"
            :withReset="true"
            v-model="temp.filter_by"
          >
            <select-option
              :key="col.value"
              v-for="col in filterBy"
              :value="col.value"
              :name="col.display"
            >
              {{ col.display }}
            </select-option>
          </select-list>
        </div>

        <div class="search-bar__items -filterby-input">
          <div class="input-wrap">
            <input
              id="q"
              type="text"
              v-model="temp.q"
            />
          </div>
        </div>
      </template>

      <div
        class="search-bar__items -dateby-dp"
        v-if="dateBy.length"
      >
        <select-list
          id="filter-by-date"
          ref="filter-by-date"
          :title="dateTitle"
          :withReset="true"
          v-model="temp.date_by"
        >
          <select-option
            :key="col.value"
            v-for="col in dateBy"
            :value="col.value"
            :name="col.display"
          >
            {{ col.display }}
          </select-option>
        </select-list>
      </div>

      <div
        class="search-bar__items -dateby-input"
        v-if="dateBy.length"
      >
        <!-- from | date -->
        <date-time-picker
          ref="datetimepickerFrom"
          v-model='temp.date_from'
          mode='from'
          :placeholder="dateRange ? '에서' : 'date'" 
          :type='dateType'
          :range="dateRange"
          :setMax='temp.date_to'
        >
        </date-time-picker>

        <!-- to | date -->
        <date-time-picker
          ref="datetimepickerTo"
          v-model='temp.date_to'
          v-if="dateRange"
          mode='to'
          placeholder='까지'
          :type='dateType'
          :range='dateRange'
          :setMin='temp.date_from'
        >
        </date-time-picker>
      </div>

      <button class="btn--search">
        <i class="ico--search"></i>
      </button>

      <button
        class="btn--clear"
        @click="clear"
      >
        <i class="ico--clear"></i>
      </button>
    </form>
  </section>
</template>

<script>
//= components
import DateTimePicker from '@/components/base/DateTimePicker'
import '@/components/base/select/Select'

export default {
  props: {
    filterBy: {
      type: Array,
      required: true
    },

    dateBy: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },

    dateRange: {
      type: Boolean,
      default: true
    },

    dateType: {
      type: String,
      default: 'datetime'
    },

    sortBy: {
      type: String,
      required: false
    },

    sort: {
      type: String,
      required: false
    },

    disabled: {
      type: Boolean,
      required: false
    },

    rows: {
      type: [Number, String],
      required: false
    }
  },

  components: {
    DateTimePicker
  },

  computed: {
    dateTitle () {
      if (this.dateBy.length) {
        return this.dateBy[0].display
      }
      return 'Filter Date'
    },

    filterTitle () {
      if (this.filterBy.length) {
        return this.filterBy[0].display
      }
      return 'Filter By'
    }
  },

  data () {
    let temp = this.generate(this.$route.query)
    if (this.dateBy.length) {
      temp.date_by = this.dateBy[0].value
    }
    if (this.filterBy.length) {
      temp.filter_by = this.filterBy[0].value
    }
    return {
      temp
    }
  },

  methods: {
    clear () {
      if (this.disabled) {
        return
      }

      this.temp = {
        rows: this.rows || 50,
        page: 1,
        filter_by: '',
        q: '',
        date_by: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      }

      if (this.dateBy.length > 0) {
        this.$refs.datetimepickerFrom.reset = true
        this.$refs.datetimepickerTo.reset = true
      }

      if (this.$refs.datetimepickerFrom) {
        this.$refs.datetimepickerFrom.resetData()
      }

      if (this.$refs.datetimepickerTo) {
        this.$refs.datetimepickerTo.resetData()
      }

      this.$refs.filter.reset = true

      if (this.$refs['filter-by-date']) {
        this.$refs['filter-by-date'].reset = true
      }

      this.$emit('trigger', this.generate(this.temp))
    },

    trigger () {
      if (this.disabled) {
        return
      }

      this.$emit('trigger', this.generate(this.temp))
    },

    refresh () {
      if (this.disabled) {
        return
      }

      this.$emit('refresh')
    }
  }
}
</script>
